<script>
import options from './StafetProfileForm.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-profile-form kb-stafet-donation-flow__step kb-optimizely-forms"
  >
    <div class="kb-stafet-step">
      <h2 class="kb-stafet-step__title">
        {{ labels.yourInformationTitle }}
      </h2>

      <div class="kb-stafet-step__input-wrapper">
        <div
          class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
        >
          <FormInputTextField
            :modelValue="userData.firstName.toString()"
            fieldName="firstName"
            :readOnly="true"
            :label="labels.yourInformationFirstNameLabel"
          />

          <FormInputTextField
            :modelValue="userData.lastName.toString()"
            fieldName="lastName"
            :readOnly="true"
            :label="labels.yourInformationLastNameLabel"
          />
        </div>

        <div
          class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
        >
          <FormInputTextField
            :modelValue="userData.phoneNumber?.toString()"
            fieldName="phoneNumber"
            :readOnly="true"
            :label="labels.yourInformationPhoneNumberLabel"
          />

          <FormInputTextField
            :modelValue="userData.email.toString()"
            fieldName="email"
            :readOnly="true"
            :label="labels.yourInformationEmailLabel"
          />
        </div>

        <div
          class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
        >
          <a class="kb-link" :href="editPasswordLink"
            >{{ labels.editProfilePasswordLinkLabel }}
          </a>
        </div>

        <div class="kb-stafet-step__input-wrapper">
          <a class="kb-link" :href="editProfileLink"
            >{{ labels.editProfileInformationLinkLabel }}
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="none"
              >
                <path
                  fill="#500778"
                  fill-rule="evenodd"
                  d="m12.978 2.708-3.864-.191-.049-.986 4.37.216c.279.014.516.246.53.518l.216 4.37-1.011-.05-.192-3.877Zm-8.924 8.23 6.734-6.734.707.707-6.734 6.734-.707-.707ZM1.5 3H1v12h12V8.313h-1V14H2V4h5.688V3H1.5Z"
                  clip-rule="evenodd"
                />
              </svg> </span
          ></a>
        </div>
      </div>

      <hr
        class="kb-stafet-step__breaker-line kb-stafet-step__breaker-line--smaller"
      />

      <h2 class="kb-stafet-step__title">
        {{ labels.emailSettingsTitle }}
      </h2>

      <div>
        <p>{{ labels.emailSettingsDescription }}</p>
        <FormCheckbox
          fieldName="mailSettingsBool"
          v-model="mailSettingsBool"
          :modelValue="mailSettingsBool.toString()"
          :label="labels.emailSettingsCheckboxNewsletterLabel"
          :onChangeCallback="(e) => setMailSettingBool(e.target.checked)"
        />
        <FormCheckbox
          fieldName="mailSettingsFighterNewsletterBool"
          v-model="mailSettingsFighterNewsletterBool"
          :modelValue="mailSettingsFighterNewsletterBool.toString()"
          :label="labels.emailSettingsCheckboxFighterNewsletterLabel"
          :onChangeCallback="(e) => setMailSettingFighterNewsletterBool(e.target.checked)"
        />
      </div>

      <div>
        <button
          v-on:click="openConfirmPageOverlay"
          class="kb-button kb-button kb-button--full-color-spot"
        >
          {{ labels.emailSettingsSaveChangesLabel }}
        </button>
      </div>

      <div>
        <hr
          class="kb-stafet-step__breaker-line kb-stafet-step__breaker-line--smaller"
        />

        <p>
          {{ labels.deleteProfileDescription }}
          <button class="kb-link" v-on:click="openDeletePageOverlay">
            {{ labels.deleteProfileButtonLabel }}
          </button>
        </p>

        <hr
          class="kb-stafet-step__breaker-line kb-stafet-step__breaker-line--smaller"
        />
      </div>
    </div>
  </article>
</template>
